import { convertDateTimeToDateString } from "./datetimeUtils";

export function toNullIfEmptyOrZero(value) {
    if (value === "" || Number(value) === 0) {
        return null;
    }
    return value;
}

export function handlePriceWithRM(price) {
    if (price == null) {
        return "";
    }
    const formatted = new Intl.NumberFormat('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(price));
    if (price < 0) {
        return "- RM " + formatted;
    }
    return "RM " + formatted;
}

export function handlePriceWithDate(price, date) {
    if (price == null || price === 0) {
        return "";
    }
    return (
        <>
            {handlePriceWithRM(price)}
            {" "}
            <span className="text-muted" style={{ fontSize: "0.85em" }}>
                ({convertDateTimeToDateString(date)})
            </span>
        </>
    );
}

// Compact RM formatter for chart axes / tight tooltips. Up to 999,999 stays
// in "Xk"; from 1,000,000 it switches to "Xmil" so we never show "1000k".
//   500       -> "RM 500"
//   12_500    -> "RM 13k"          (rounded to nearest k)
//   100_000   -> "RM 100k"
//   999_000   -> "RM 999k"
//   1_000_000 -> "RM 1mil"
//   1_500_000 -> "RM 1.5mil"
//   2_345_678 -> "RM 2.3mil"
export function formatCompactRm(v, withRm = true) {
    const num = Number(v) || 0;
    const abs = Math.abs(num);
    let body;
    if (abs >= 1_000_000) {
        const mil = num / 1_000_000;
        body = (Math.round(mil * 10) / 10).toString().replace(/\.0$/, '') + 'mil';
    } else if (abs >= 1_000) {
        body = Math.round(num / 1_000).toString() + 'k';
    } else {
        body = Math.round(num).toString();
    }
    return withRm ? `RM ${body}` : body;
}

// This function is not in used
export function handleFormatPriceString(priceString) {
    const formattedPrice = new Intl.NumberFormat("en-MY", {
        style: "currency",
        currency: "MYR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(priceString);

    return formattedPrice;
}